import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUser,
  faStore,
  faMapMarkerAlt,
  faBuilding,
  faGlobe,
  faLayerGroup,
  faChevronDown,
} from "@fortawesome/free-solid-svg-icons";

const SCOPE_ICON = {
  expert: faUser,
  assistant: faUser,
  agency: faStore,
  agencies: faLayerGroup,
  region: faMapMarkerAlt,
  group: faBuilding,
  network: faGlobe,
  all: faGlobe,
};

const SCOPE_COLOR = {
  expert: "#7c3aed",
  assistant: "#7c3aed",
  agency: "#0e7490",
  agencies: "#0e7490",
  region: "#0d9488",
  group: "#1d4ed8",
  network: "#475569",
  all: "#475569",
};

export default class PerimeterBadge extends Component {
  constructor(props) {
    super(props);
    this.state = { open: false };
    this.wrapRef = React.createRef();
    this.handleDocClick = this.handleDocClick.bind(this);
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleDocClick);
  }
  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleDocClick);
  }
  handleDocClick(e) {
    if (this.wrapRef.current && !this.wrapRef.current.contains(e.target)) {
      this.setState({ open: false });
    }
  }

  render() {
    const { perimeter, compact, style } = this.props;
    if (!perimeter) return null;

    const icon = SCOPE_ICON[perimeter.scope] || faStore;
    const color = SCOPE_COLOR[perimeter.scope] || "#475569";
    const hasDetails =
      (perimeter.agencies && perimeter.agencies.length > 0) ||
      perimeter.region ||
      perimeter.group ||
      perimeter.network;

    const baseStyle = {
      display: "inline-flex",
      alignItems: "center",
      gap: "6px",
      padding: compact ? "2px 8px" : "4px 10px",
      backgroundColor: `${color}14`,
      color,
      borderRadius: "12px",
      fontSize: compact ? "11px" : "12px",
      fontWeight: 500,
      border: `1px solid ${color}33`,
      whiteSpace: "nowrap",
      cursor: hasDetails ? "pointer" : "default",
      userSelect: "none",
      ...(style || {}),
    };

    return (
      <span
        ref={this.wrapRef}
        style={{ position: "relative", display: "inline-block" }}
      >
        <span
          style={baseStyle}
          onClick={() =>
            hasDetails && this.setState((s) => ({ open: !s.open }))
          }
          title={hasDetails ? "Voir le détail du périmètre" : null}
        >
          <FontAwesomeIcon icon={icon} style={{ fontSize: "10px" }} />
          <span>{perimeter.label}</span>
          {hasDetails && (
            <FontAwesomeIcon
              icon={faChevronDown}
              style={{
                fontSize: "9px",
                transition: "transform 0.2s",
                transform: this.state.open ? "rotate(180deg)" : "none",
              }}
            />
          )}
        </span>

        {this.state.open && (
          <div
            style={{
              position: "absolute",
              top: "calc(100% + 6px)",
              right: 0,
              minWidth: "260px",
              maxWidth: "360px",
              backgroundColor: "#fff",
              border: "1px solid #e5e7eb",
              borderRadius: "8px",
              boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
              padding: "12px 14px",
              zIndex: 1000,
              fontSize: "12px",
              color: "#1f2937",
              fontWeight: 400,
              whiteSpace: "normal",
              cursor: "default",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div
              style={{
                fontWeight: 600,
                fontSize: "11px",
                color,
                textTransform: "uppercase",
                letterSpacing: "0.5px",
                marginBottom: "8px",
              }}
            >
              <FontAwesomeIcon
                icon={icon}
                style={{ marginRight: "6px", fontSize: "10px" }}
              />
              Périmètre des données
            </div>

            {perimeter.name && (
              <DetailRow label="Utilisateur" value={perimeter.name} />
            )}
            {perimeter.roleStr && (
              <DetailRow label="Rôle" value={perimeter.roleStr} />
            )}
            {perimeter.network && (
              <DetailRow label="Réseau" value={perimeter.network} />
            )}
            {perimeter.group && (
              <DetailRow label="Cabinet" value={perimeter.group} />
            )}
            {perimeter.region && (
              <DetailRow label="Région" value={perimeter.region} />
            )}

            {perimeter.agencies && perimeter.agencies.length > 0 && (
              <div style={{ marginTop: "8px" }}>
                <div
                  style={{
                    fontSize: "11px",
                    color: "#6b7280",
                    marginBottom: "4px",
                  }}
                >
                  {perimeter.agencies.length === 1
                    ? "Agence"
                    : `${perimeter.agencies.length} agences`}
                </div>
                <ul
                  style={{
                    margin: 0,
                    padding: 0,
                    listStyle: "none",
                    maxHeight: "240px",
                    overflowY: "auto",
                  }}
                >
                  {perimeter.agencies.map((name, idx) => (
                    <li
                      key={idx}
                      style={{
                        padding: "4px 8px",
                        marginBottom: "2px",
                        backgroundColor: `${color}0a`,
                        borderLeft: `2px solid ${color}`,
                        borderRadius: "2px",
                      }}
                    >
                      {name}
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        )}
      </span>
    );
  }
}

function DetailRow({ label, value }) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        gap: "12px",
        padding: "3px 0",
      }}
    >
      <span style={{ color: "#6b7280" }}>{label}</span>
      <span style={{ fontWeight: 500, textAlign: "right" }}>{value}</span>
    </div>
  );
}
